import { Questionnaire } from 'commons/types/DTO/commons'

import { QuestionnaireFormValue } from '../../../../types'

export const mapQuestionnaireForm = (formValues: QuestionnaireFormValue): Questionnaire => ({
  ...formValues
})
